import type { AgentChatListItem } from '@/api/client';

export function areAgentChatListItemsEqual(a: AgentChatListItem, b: AgentChatListItem): boolean {
  return (
    a.id === b.id &&
    (a.title ?? '') === (b.title ?? '') &&
    (a.summary ?? null) === (b.summary ?? null) &&
    (a.last_message_at ?? null) === (b.last_message_at ?? null) &&
    (a.last_model_slot ?? null) === (b.last_model_slot ?? null) &&
    (a.unread_count ?? 0) === (b.unread_count ?? 0) &&
    Boolean(a.processing) === Boolean(b.processing) &&
    (a.processing_phase ?? null) === (b.processing_phase ?? null) &&
    a.created_at === b.created_at &&
    a.updated_at === b.updated_at
  );
}
